import React from 'react';

import whiteLabelPdfThumbnailImg from '@hydra/assets/img/pdf-editor/white_label_pdf_thumbnail.svg';

import { Container, Paper, Grid, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Image, Translate } from '@hydra/common/components';

import { useI18n } from '@hydra/common/customHooks';

const useStyles = makeStyles(theme => ({
  grid: {
    display: 'flex',
    padding: theme.spacing(5.5),
    columnGap: theme.spacing(5.5),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      rowGap: theme.spacing(2)
    }
  },
  img: {
    maxWidth: '50%',
    margin: '0 auto',
    [theme.breakpoints.down('xs')]: {
      minWidth: '70%'
    },
    [theme.breakpoints.down(525)]: {
      minWidth: '100%'
    }
  },
  info: {
    maxWidth: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    rowGap: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
      alignItems: 'center'
    }
  },
  text: {
    fontWeight: theme.typography.fontWeightSemibold,
    lineHeight: 'normal',
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.spacing(2.5)
    }
  },
  button: {
    width: 'fit-content'
  }
}));

export function PdfEditorBannerCTA () {
  const classes = useStyles();
  const { locale } = useI18n();
  return (
    <Container maxWidth='lg'>
      <Typography component='div'>
        <Paper>
          <Grid item container wrap='nowrap' className={classes.grid}>
            <Image className={classes.img} src={whiteLabelPdfThumbnailImg} />
            <Grid item container wrap='nowrap' zeroMinWidth className={classes.info}>
              <Typography variant='h3' className={classes.text}>
                <Translate content='pdf_editor_upgrade_text' />
              </Typography>
              <Button
                variant='outlined'
                color='primary'
                className={classes.button}
                href={`/${locale}/user/plan`}
              >
                <Translate content='pdf_editor_upgrade_button_text' />
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Typography>
    </Container>
  );
}

export default PdfEditorBannerCTA;
